import { render, staticRenderFns } from "./CustomerFormERPEmbeddable.vue?vue&type=template&id=1b13bb91&"
import script from "./CustomerFormERPEmbeddable.vue?vue&type=script&lang=js&"
export * from "./CustomerFormERPEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports